@use '../styles/tokens' as *;

// ----- BenefitItem -----
.benefit {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
.benefitCheck {
  flex: none;
  width: 15px;
  height: 15px;
  margin-top: 2px;
  color: $enscape;
}
.benefitLabel {
  @include text-13;
  color: $base-3;
}
.compact {
  .benefitCheck {
    color: $blue-gray-4;
    width: 13px;
    height: 13px;
    margin-top: 1px;
  }
  .benefitLabel {
    @include text-11;
    line-height: 14px;
    color: $blue-gray-1;
  }
}

// ----- QuantityField -----
.qtyField {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.qtyLabel {
  @include text-11;
  color: $base-4;
}
.qtyBox {
  display: flex;
  align-items: center;
  height: 25px;
  width: 64px;
  padding: 0 4px 0 10px;
  border: 1px solid $blue-gray-7;
  border-radius: 8px;
  background: $blue-gray-9-5;
}
.qtyInput {
  flex: 1;
  min-width: 0;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  @include text-11;
  color: $black;
  outline: none;
}
.qtyBoxLocked {
  background: $blue-gray-8;

  .qtyInput {
    color: $base-5;
  }
}
.qtyLock {
  flex: none;
  width: 14px;
  height: 14px;
  color: $base-4;
}
.qtyArrows {
  display: flex;
  flex-direction: column;
}
.qtyArrow {
  display: inline-flex;
  padding: 0;
  border: none;
  background: none;
  color: $base-4;

  svg {
    width: 12px;
    height: 12px;
  }
}

// ----- RemoveButton -----
.remove {
  padding: 0;
  border: none;
  background: none;
  @include text-11;
  color: $base-5;
  text-decoration: underline;
}

// ----- PriceTag -----
.price {
  font-weight: 600;
  color: $blue-gray-1;
}
.priceAmount {
  @include text-body-1;
}
.priceSup {
  @include text-13;
}
.priceNote {
  @include text-10;
  color: $base-5;
}

// ----- PromoCodeField -----
.promo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.promoToggle {
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  @include lg {
    cursor: default;
  }
}
.promoChevron {
  width: 14px;
  height: 14px;
  color: $base-4;

  @include lg {
    display: none;
  }
}
.promoBody {
  display: none;
  flex-direction: column;

  @include lg {
    display: flex;
  }
}
.promoBodyOpen {
  display: flex;
}
.promoLabel {
  @include text-11;
  color: $base-4;
}
.promoLabelOk {
  color: $utility-green;
}
.promoLabelError {
  color: $brand;
}
.promoRow {
  display: flex;
  align-items: center;
  gap: 10px;
}
.promoInputWrap {
  position: relative;
  display: flex;
  align-items: center;
}
.promoInput {
  height: 30px;
  width: 160px;
  padding: 0 30px 0 10px;
  border: 1px solid $blue-gray-7;
  border-radius: 4px;
  background: $blue-gray-9-5;
  @include text-11;
  color: $black;
}
.promoClear {
  position: absolute;
  right: 8px;
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: $base-5;
}
.promoClearIcon {
  width: 14px;
  height: 14px;
}
.promoInputOk {
  border-color: $utility-green;
}
.promoInputError {
  border-color: $brand;
}
.promoApply {
  padding: 0;
  border: none;
  background: none;
  @include text-13;
  font-weight: 700;
  color: $black;
}
.promoMsg {
  margin-top: 4px;
  @include text-10;
}
.promoMsgError {
  color: $brand;
}
.promoMsgOk {
  color: $utility-green;
}

// ----- Notice (NoticeList) -----
.notice {
  padding: 15px;
  border: 1px solid $brand;
  border-radius: 20px;
  background: rgba(225, 22, 28, 0.1);
}
.noticeSuccess {
  border-color: $utility-green;
  background: rgba(119, 178, 42, 0.06);
}
.noticeTitle {
  display: flex;
  align-items: center;
  gap: 5px;
  @include text-13;
  font-weight: 700;
  color: $brand;
}
.noticeSuccess .noticeTitle {
  color: $utility-green;
}
.noticeIcon {
  width: 16px;
  height: 16px;
  flex: none;
}
.noticeBody {
  margin-top: 8px;
  @include text-13;
  color: $black;
}

// ----- OrderTotals -----
.totals {
  display: flex;
  flex-direction: column;
}
.totalsSub {
  display: flex;
  flex-direction: column;
  color: $blue-gray-5;
  margin: 10px 0;
}
.totalsRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.totalsRowSub {
  @include text-13;
}
.totalsRowSmall {
  @include text-11;
}
.totalsRowDiscount {
  @include text-11;
  color: $utility-green;
}
.totalsValueSemi {
  font-weight: 600;
}
.totalsGrand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $blue-gray-2;
}
.totalsGrandLabel {
  @include text-body-1;
}
.totalsGrandValue {
  @include text-body-1;
  font-weight: 600;
}

// ----- OrderLineItems -----
.lines {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  display: none;

  @include lg {
    display: block;
  }
}
.line {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $blue-gray-7;

  &:not(:first-child) {
    padding-top: 10px;
  }
}
.lineName {
  @include text-body-2;
  font-weight: 600;
  color: $blue-gray-2;
}
.lineMeta {
  @include text-11;
  color: $blue-gray-4;
}
.linePrice {
  @include text-body-2;
  color: $blue-gray-2;
  white-space: nowrap;
}

// ----- Stars -----
.stars {
  display: flex;
  gap: 2px;
  color: $phoenix;
}
.star {
  position: relative;
  display: inline-flex;

  svg {
    width: 20px;
    height: 20px;
  }
}
.starBase {
  color: $blue-gray-7;
}
.starFill {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

// ----- PaymentMethods -----
.payments {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.payLabel {
  @include text-11;
  color: $blue-gray-5;
  white-space: nowrap;
}
.payList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
  gap: 8px;
}
.payMark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  font-weight: 700;
  font-style: italic;
  letter-spacing: 0.3px;
  font-size: 11px;
}
.mc {
  position: relative;
  width: 26px;
  height: 16px;
}
.mcCircle {
  position: absolute;
  top: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.mcRed {
  left: 0;
  background: #eb001b;
}
.mcYellow {
  right: 0;
  background: #f79e1b;
  mix-blend-mode: multiply;
}
.visa {
  color: #1a1f71;
}
.amex {
  font-style: normal;
  color: $white;
  background: #2e77bc;
  border-radius: 3px;
  padding: 0 3px;
  font-size: 8px;
  letter-spacing: 0.2px;
}
.paypalA {
  color: #003087;
}
.paypalB {
  color: #009cde;
}
.discover {
  font-style: normal;
  font-size: 9px;
  color: $blue-gray-2;
}
.discoverDot {
  color: #f76b1c;
}
